import React from "react";
import { FiPlus } from "react-icons/fi";
import { PALETTE } from "../ThemeConstants";

export default function AddButton({
  size = 150,
  onClick,
  roundedBottomLeft = 0,
  roundedBottomRight = 0,
  roundedTopLeft = 0,
  roundedTopRight = 0,
}) {
  return (
    <div
      id="add-button"
      className="p-2"
      style={{
        cursor: "pointer",
        width: "fit-content",
        color: PALETTE.GRAY,
        background: PALETTE.KINDALIGHTGRAY,
        borderRadius: `${roundedTopLeft}px ${roundedTopRight}px ${roundedBottomRight}px ${roundedBottomLeft}px`,
      }}
      onClick={onClick}
      onMouseEnter={(event) => {
        let ref = document.querySelector("#add-button");
        ref.style.color = PALETTE.SECONDARYCOLORHOVER;
      }}
      onMouseLeave={(event) => {
        let ref = document.querySelector("#add-button");
        ref.style.color = PALETTE.GRAY;
      }}
    >
      <FiPlus size={size} />
    </div>
  );
}
